import { liteClient as algoliasearch } from 'algoliasearch/lite';
import { Configure, InstantSearch } from 'react-instantsearch';

import InstantSearchRedirect from '../features/instantSearchRedirect';
import SearchClientProvider from './searchClientProvider';
import { ScrollToTopOnFirstPage } from '../features/ScrollToTopOnFirstPage';

import routing from './routing';

export interface InstantSearchConfig {
  apiKey: string;
  appId: string;
  autoCompleteIndexName: string;
  indexName: string;
  initialState: { make: string; model: string } | null;
  userToken: string;
  syncURL?: boolean;
}

export type InstantSearchInitialState = {
  make: string;
  model: string;
};

const InstantSearchProvider = ({
  apiKey,
  appId,
  children,
  autoCompleteIndexName,
  indexName,
  initialState,
  syncURL = false,
  userToken,
}: React.PropsWithChildren<
  InstantSearchConfig & {
    initialState: InstantSearchInitialState | null;
  }
>) => {
  const searchClient = algoliasearch(appId, apiKey);

  return (
    <InstantSearch
      indexName={indexName}
      insights={!!userToken && { insightsInitParams: { userToken } }}
      routing={syncURL && routing(indexName, initialState)}
      searchClient={searchClient}
    >
      <ScrollToTopOnFirstPage />
      <InstantSearchRedirect />
      <Configure hitsPerPage={24} maxValuesPerFacet={100} />
      <SearchClientProvider
        autocompleteIndexName={autoCompleteIndexName}
        indexName={indexName}
        searchClient={searchClient}
      >
        {children}
      </SearchClientProvider>
    </InstantSearch>
  );
};

export default InstantSearchProvider;
